/* eslint-disable no-unused-vars */
import { fetchClient } from '../../Utils/helpers';
import { getUserData } from '../../Utils/storages';
import {
  ASSIGN_COURIER,
  ASSIGN_ITEMS_TO_BOX,
  DECLINE_REQUEST,
  GET_REQUESTS,
  GET_REQUEST_DETAILS,
  GET_REQUEST_HISTORY,
  REQUEST_IN,
  REQUEST_ITEM,
  REQUEST_OUT,
  UPDATE_REQUEST,
  UPDATE_REQUEST_IN,
  VALIDATE_ITEMS,
} from '../actionTypes';

const userData = getUserData();
const role = userData.role_id;

export function createRequestIn(uid, data) {
  return {
    type: REQUEST_IN,
    payload: fetchClient({
      method: 'POST',
      url: `/user/request/${uid}`,
      data,
    }),
  };
}

export function updateRequestIn(uid, reqId, data) {
  return {
    type: UPDATE_REQUEST_IN,
    payload: fetchClient({
      method: 'PUT',
      url: `/user/${uid}/request/${reqId}`,
      data,
    }),
  };
}

export function createRequestOut(uid, data) {
  return {
    type: REQUEST_OUT,
    payload: fetchClient({
      method: 'POST',
      url: '/v2/user/request-out',
      data,
    }).then((res) => {
      if (res.data.data?.url) {
        window.location.href = res.data.data?.url;
      }

      return res;
    }),
  };
}

export function createRequestItem(uid, data) {
  return {
    type: REQUEST_ITEM,
    payload: fetchClient({
      method: 'POST',
      url: `/user/request-find/${uid}`,
      data,
    }),
  };
}

export function getRequests(uid) {
  return {
    type: GET_REQUESTS,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${uid}/request`,
    }),
  };
}

export function getCourierRequests() {
  return {
    type: GET_REQUESTS,
    payload: fetchClient({
      method: 'GET',
      url: '/courier/request',
    }),
  };
}

export function getCourierRequestDetails(id) {
  return {
    type: GET_REQUEST_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/courier/request/${id}`,
    }),
  };
}

export function getAdminRequestDetails(id) {
  return {
    type: GET_REQUEST_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/request/${id}`,
    }),
  };
}

export function getAdminRequests(query) {
  const {
    page, limit, status, type, sort,
  } = query;
  return {
    type: GET_REQUESTS,
    payload: fetchClient({
      method: 'GET',
      url: `/${role === 'Warehouse Manager'
        ? 'warehouse-manager' : 'admin'}/requests?page=${page || 1}&limit=${limit || 10}&status=${status || ''}&type=${type || ''}&sort=${sort || ''}`,
    }).then((res) => res.data),
  };
}

export function assignCourier(requestId, data) {
  return {
    type: ASSIGN_COURIER,
    payload: fetchClient({
      method: 'PATCH',
      url: `/${role === 'Warehouse Manager' ? 'warehouse-manager' : 'admin'}/request/${requestId}/assign`,
      data,
    }),
  };
}

export function declineRequest(requestId, data) {
  return {
    type: DECLINE_REQUEST,
    payload: fetchClient({
      method: 'PUT',
      url: `/admin/request/${requestId}`,
      data,
    }),
  };
}

export function setRequestAsDone(requestId) {
  return {
    type: VALIDATE_ITEMS,
    payload: fetchClient({
      method: 'PATCH',
      url: `/warehouse-manager/request/${requestId}/done`,
    }),
  };
}

export function validateItems(requestId, data) {
  return {
    type: VALIDATE_ITEMS,
    payload: fetchClient({
      method: 'PATCH',
      url: `/courier/request/${requestId}/confirm`,
      data,
    }),
  };
}

export function validatePickup(requestId, data) {
  return {
    type: VALIDATE_ITEMS,
    payload: fetchClient({
      method: 'PATCH',
      url: `/courier/request-out/${requestId}/confirm`,
      data,
    }),
  };
}

export function finishRequestOut(requestId, data) {
  return {
    type: VALIDATE_ITEMS,
    payload: fetchClient({
      method: 'PATCH',
      url: `/courier/request-out/${requestId}/finish`,
      data,
    }),
  };
}

export function updateCourierRequest(requestId, data) {
  return {
    type: UPDATE_REQUEST,
    payload: fetchClient({
      method: 'PATCH',
      url: `/courier/request/${requestId}`,
      data,
    }),
  };
}

export function assignItemsToBox(requestId, data) {
  return {
    type: ASSIGN_ITEMS_TO_BOX,
    payload: fetchClient({
      method: 'PATCH',
      url: `/warehouse-manager/request/${requestId}/validate-item`,
      data,
    }).then((res) => {
      res.requestId = requestId;
      return res;
    }),
  };
}

export function getRequestHistory(userId, type, status, page) {
  let basePath = `/user/${userId}/request-history`;
  if (role === 'Kurir' || role === 'Courier') {
    basePath = '/courier/request-history';
  }
  return {
    type: GET_REQUEST_HISTORY,
    payload: fetchClient({
      method: 'GET',
      url: `${basePath}?limit=10&page=${page}&type=${type}&status=${status}`,
    }),
  };
}

export function getHistoryDetails(userId, historyId) {
  return {
    type: GET_REQUEST_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${userId}/request-history/${historyId}`,
    }),
  };
}

export function downloadRequestReport(body) {
  const { startDate, endDate, type } = body;

  const exportData = (data, fileName) => {
    // Create a link and download the file
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return {
    type: 'DOWNLOAD_REQUESTS_REPORT',
    payload: fetchClient({
      method: 'GET',
      url: `/admin/requests/download?date_from=${startDate}&date_until=${endDate}&request_type=${type}`,
    }).then((response) => {
      exportData(response.data, 'data.csv');

      return response;
    }),
  };
}
